export enum FormFieldKeyConditionEnum {
    EqualsTo = 1,
    EqualsOrGreater = 2,
    EqualsOrLess = 3,
    Greater = 4,
    Less = 5,
    Contains = 6,
    NotEqualsTo = 7
}